@if (!mobile) {
  <h1
    mat-dialog-title>
    {{ 'default.printInstruction' | blah }}
  </h1>
}

@if (!mobile) {
  <mat-dialog-content>
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </mat-dialog-content>
} @else {
  <p class="description">
    {{ 'default.selectBlocksToPrint' | blah }}
  </p>
  <div class="checkbox-container">
    @for (item of items; track item) {
      <mat-checkbox
        id="print-dialog-item-{{item.id}}-checkbox"
        [(ngModel)]="item.selected">
        {{item.title}}
      </mat-checkbox>
    }
  </div>
}

<ng-template #content>

  <p class="description">
    {{ 'default.selectBlocksToPrint' | blah }}
  </p>

  <div class="checkbox-container">

    @for (item of items; track item) {
      <mat-checkbox
        id="print-dialog-item-{{item.id}}-checkbox"
        [(ngModel)]="item.selected">
        {{item.title}}
      </mat-checkbox>
    }

  </div>

</ng-template>

@if (!mobile) {
  <mat-dialog-actions
    align="end">
    <button id="print-dialog-cancel-button"
      mat-stroked-button
      mat-dialog-close>
      {{ 'default.cancel' | blah | uppercase }}
    </button>
    <button id="print-dialog-print-button"
      mat-stroked-button
      color="accent"
      (click)="printSelected()">
      {{ 'default.print' | blah | uppercase }}
    </button>
  </mat-dialog-actions>
}